import {LitElement, html, css} from 'lit';
import {property} from 'lit/decorators/property.js';
import {state} from 'lit/decorators/state.js';
import {customElement} from 'lit/decorators/custom-element.js';
import {repeat} from 'lit/directives/repeat.js';
import {when} from 'lit/directives/when.js';
import {classMap} from 'lit/directives/class-map.js';
import {connect} from 'pwa-helpers';
import down from '../../../icons/down';
import info from '../../../icons/info';

import store from '../../store';

import {staggeredReveal} from '../../css/styleSets';
import {iomoMaterials} from '../iomoMaterial';
import {selectIomoCustomColor, selectIomoCustomColorUse} from '../iomoSelectors';
import {setIomoCustomColorUse, setIomoCustomColorUsed} from '../iomoSlice';

@customElement('custom-color-select')
export class CustomColorSelect extends connect(store)(LitElement) {

	@property({type: Object})
	title = {
		de: '[Titel]',
		en: '[Title]',
		fr: '[Title]'
	};

	@property({type: Function})
	isSatisfied = null;

	@state({type: String})
	activeType = null;

	static styles = [
		staggeredReveal,
		css`
			:host {
				display: flex;
				flex-direction: column;
			}

			.title {
				display: flex;
				justify-content: space-between;
				align-items: center;
				font: var(--font-widget-title);
				color: var(--color-widget-text);
				margin-bottom: 12px;

				flex-direction: row;
				font: var(--font-widget-label);
				transition: background-color 0.4s ease-out, color 0.4s ease-out;
			}

			button {
				font: var(--font-widget-label);
				width: 20px;
				height: 20px;
				border-radius: 10px;
				background-color: transparent;
				color: var(--color-black);
				border: 1px solid var(--color-black);;
				cursor: pointer;
				transition: background-color 0.4s ease-out, color 0.4s ease-out;
			}

			.active button {
				background-color: var(--color-black);
				color: var(--color-white);
			}

			button.toggle {
				height: 24px;
				width: 50px;
				border-radius: 12px;
				border: 0 none;
				background-color: var(--color-grey5);
				color: var(--color-widget-border);
			}

			.knob {
				display: block;
				height: 18px;
				width: 18px;
				border-radius: 9px;
				background-color: var(--color-grey6);
				margin: 0 -10%;
				transition: margin 0.4s ease-out;
			}

			.active .knob {
				margin: 0 60%;
			}


			.info {
				color: var(--color-widget-infoicon);
				background-color: transparent;
				cursor: pointer;
				transition: background-color 0.4s, color 0.4s;
				border: none;
				padding: 0;
			}

			.info:hover {
				color: var(--color-widget-text);
			}

			.info svg path {
				fill: currentColor;
				stroke: currentColor;
			}

			.info svg circle {
				stroke: currentColor;
			}

			.colors {
				display: none;
				flex-direction: column;
				margin-bottom: var(--very-small-padding);
			}

			.colors.active {
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
			}

			.color {
				flex-basis: 50%;
			}

			.colorType {
				display: flex;
				flex-direction: row;
				color: var(--color-widget-text);
				font: var(--font-widget-title);
				height: 48px;
				cursor: pointer;
				box-shadow: 1px 0 0 0 var(--color-widget-border),
				0 1px 0 0 var(--color-widget-border),
				1px 1px 0 0 var(--color-widget-border),
				1px 0 0 0 var(--color-widget-border) inset,
				0 1px 0 0 var(--color-widget-border) inset;
			}

			.colorTypeThumbnail {
				background: #999;
				width: 48px;
				height: 48px;
				aspect-ratio: 1;
				flex-basis: 48px;
				box-shadow: 1px 0 0 0 var(--color-widget-border),
				0 1px 0 0 var(--color-widget-border),
				1px 1px 0 0 var(--color-widget-border),
				1px 0 0 0 var(--color-widget-border) inset,
				0 1px 0 0 var(--color-widget-border) inset;
			}

			.thumbnail {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}

			.colorTypeLabel {
				color: var(--color-widget-text);
				font: var(--font-widget-title);
				flex-basis: 100%;
				align-content: center;
				padding: 0 var(--very-small-padding);
			}

			.colorTypeToggle {
				color: var(--color-widget-text);
				font: var(--font-widget-title);
				flex-basis: 48px;
				align-content: center;
				padding: 0 var(--very-small-padding);
			}


			.colorType {
				display: flex;
			}

			.satisfied {
				color: var(--color-text-widget-title);
			}

			.notSatisfied {
				color: var(--color-warn);
			}
		`];

	colorTypes = [
		{
			id: 'base',
			label: {
				de: 'Basis',
				en: 'Base',
				fr: 'Base'
			},
		},
		{
			id: 'head',
			label: {
				de: 'Kopf',
				en: 'Head',
				fr: 'Head'
			},
		},
		{
			id: 'ring',
			label: {
				de: 'Akzent',
				en: 'Accent',
				fr: 'Accent'
			},
		}

	]

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
		this.materials = Object.values(iomoMaterials);
	}

	stateChanged(s) {
		this.lang = s.status.lang;
		this.loggedIn = s.userProfile.data.loggedIn;
		this.customColor = selectIomoCustomColor(s);
		this.useCustomColor = selectIomoCustomColorUse(s);
	}

	firstUpdated() {
	}

	toggleType(typeId) {
		store.dispatch(setIomoCustomColorUsed({type: typeId, used: !this.customColor[typeId].used}));
	}

	handleTypeKeydown(event, typeId) {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			this.toggleType(typeId);
		}
	}

	isCustomColorUsed(type) {
		return this.customColor[type].used;
	}


	render() {
		const s = store.getState();
		return html`
			<div class="${classMap({expanded: this.useCustomColor})}">
				<div class="colorTypes">
					${repeat(this.colorTypes,
						(colorType) => colorType.id,
						(colorType) => {
							const active = this.isCustomColorUsed(colorType.id);
							return html`
								<div class="colorType ${classMap({active: active})}"
								     role="button"
								     tabindex="0"
								     aria-expanded="${active}"
								     aria-controls="colorTypes-${colorType.id}"
								     @keydown=${e => this.handleTypeKeydown(e, colorType.id)}>
									<div class="colorTypeLabel">${colorType.label[this.lang]}</div>
									${when(colorType.id !== 'base', () => html`
										<span class="colorTypeToggle switch ${classMap({active: active})}">
											<button class="toggle" @click=${() => this.toggleType(colorType.id)}>
												<div class="knob"></div>
											</button>
										</span>
									`)}
								</div>

								<div id="colors-${colorType.id}" class="colors ${classMap({active: active})}" ?hidden=${!active}>
									${repeat(this.materials,
										(material) => material.id,
										(material) => html`
											${when(!material.requireLogin || (material.requireLogin && this.loggedIn), () => html`
													<custom-color-select-item class="color"
													                          .option=${material}
													                          .type=${colorType.id}
													                          .hideDisabled=${this.hideDisabled}>
													</custom-color-select-item>`,
												() => null
											)}
										`)}
									<div></div>
								</div>
							`;
						})}
				</div>
		`;
	}
}
